import actions from './actions';
import getters from './getters';
import mutations from './mutations';

const state = {
	isLogin: false,
	userName: '',
	userId: '',
	photo: '',
	userToken: '',
	appLogoURL: ''
}

export default {
	state,
	getters,
	actions,
	mutations
};